const FORM_LIST = {
  // 实验仪器
  template_1: [
    { tag: 'el-input', label: '规格型号', value: 'specModel' },
    { tag: 'el-input', label: '总功率', value: 'totalPower' },
    { tag: 'el-input', label: '尺寸', value: 'size' },
    { tag: 'CustomNumInput', label: '净重（kg)', value: 'netWeight' },
    { tag: 'CustomNumInput', label: '货期（天）', value: 'deliveryDays' },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    {
      tag: 'el-radio',
      label: '是否为代理',
      value: 'proxyFlag',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'CustomNumInput', label: '起订量', value: 'miniOrderNum' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' }
  ],
  template_2: [
    { tag: 'el-input', label: '品牌', value: 'brand' },
    { tag: 'el-input', label: '材质', value: 'material' },
    { tag: 'el-input', label: '规格型号', value: 'specModel' },
    { tag: 'CustomNumInput', label: '净重（kg)', value: 'netWeight' },
    { tag: 'CustomNumInput', label: '货期（天）', value: 'deliveryDays' },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'CustomNumInput', label: '起订量', value: 'miniOrderNum' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' }
  ],
  template_3: [
    { tag: 'el-input', label: '品牌', value: 'brand' },
    { tag: 'el-input', label: '规格/型号/配置', value: 'parameters', type: 'textarea', maxlength: 100 },
    { tag: 'el-input', label: '售后人员响应周期', value: 'responseTime' },
    { tag: 'CustomNumInput', label: '货期（天）', value: 'deliveryDays' },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'CustomNumInput', label: '起订量', value: 'miniOrderNum' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 },
  ],
  template_4: [
    { tag: 'el-input', label: '服务内容', value: 'serviceContents', maxlength: 1000 },
    { tag: 'el-input', label: '最短服务周期', value: 'shortestServicePeriod' },
    { tag: 'el-input', label: '商务流程时间', value: 'businessProcessTime' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'CustomNumInput', label: '起订量', value: 'miniOrderNum' },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 },
  ],
  template_5: [
    { tag: 'el-input', label: '服务内容', value: 'serviceContent', type: 'textarea', maxlength: 1000 },
    { tag: 'el-input', label: '规格/型号', value: 'specModel', type: 'textarea', maxlength: 100 },
    { tag: 'el-input', label: '材质', value: 'material' },
    { tag: 'el-input', label: '公司地址', value: 'companyAddress', type: 'textarea', maxlength: 100 },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'el-input', label: '服务客户', value: 'serviceClient', type: 'textarea', maxlength: 500 },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 }
  ],
  template_6: [
    { tag: 'el-input', label: '服务周期', value: 'servicePeriod' },
    { tag: 'CustomNumInput', label: '样品量', value: 'sampleAmout', limitNum: 0 },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    {
      tag: 'el-radio',
      label: '是否有CNAS',
      value: 'hasCnas',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    {
      tag: 'el-radio',
      label: '是否有CMA',
      value: 'hasCma',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 }
  ],
  template_7: [
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    {
      tag: 'DictSelect',
      label: '服务类别',
      value: 'serviceCategory',
      type: 'cml_pd_service_category'
    },
    { tag: 'el-input', label: '服务内容', value: 'serviceContent', type: 'textarea', maxlength: 1000 },
    { tag: 'el-input', label: '服务准备周期', value: 'serviceReadyPeriod' },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 }
  ],
  template_8: [
    { tag: 'el-input', label: '服务内容', value: 'serviceContent', type: 'textarea', maxlength: 1000 },
    { tag: 'el-input', label: '服务准备周期', value: 'serviceReadyPeriod' },
    
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 }
  ],
  template_9: [
    { tag: 'el-input', label: '服务内容', value: 'serviceContent', type: 'textarea', maxlength: 1000 },
    { tag: 'el-input', label: '访谈场所地址', value: 'interviewVenueAddress' },
    { tag: 'el-input', label: '服务准备周期', value: 'serviceReadyPeriod' },
    { tag: 'el-input', label: '历史合作案例', value: 'historicalCase', type: 'textarea', maxlength: 1000 },
    { tag: 'el-input', label: '历史合作需求人', value: 'historicalDemander' },
    { tag: 'CustomNumInput', label: '含税单价（元）', value: 'includeTaxPrice' },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 }
  ],
  template_10: [
    {
      tag: 'el-date-picker',
      label: '时间',
      value: 'projectDate',
      type: 'date',
      valueFormat: 'yyyy-MM-dd',
      format: 'yyyy-MM-dd HH:mm:ss'
    },
    { tag: 'el-input', label: '地点', value: 'location' },
    { tag: 'el-input', label: '需求人', value: 'demander' },
    { tag: 'el-input', label: '需求部门', value: 'demanderDept' },
    { tag: 'el-input', label: '项目预算', value: 'budget' },
    { tag: 'DictSelect', label: '付款方式', value: 'payMethod',type: 'cml_pd_pay_method' },
    { tag: 'DictSelect', label: '发票', value: 'invoice',type: 'cml_pd_invoice_type' },
    { tag: 'CustomNumInput', label: '税率（%）', value: 'taxRate' },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    {
      tag: 'el-radio',
      label: '是否签订框架协议',
      value: 'hasFrameworkAgreement',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'el-input', label: '备注', value: 'remark', type: 'textarea', maxlength: 1000 }
  ],
  template_11: [
    { tag: 'el-input', label: '材质', value: 'material' },
    { tag: 'el-input', label: '尺寸', value: 'size' },
    { tag: 'el-input', label: '工艺', value: 'craft' },
    {
      tag: 'el-radio',
      label: '是否有专利',
      value: 'havePatent',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
    { tag: 'CustomNumInput', label: '打样时间', value: 'proofingTime' },
    { tag: 'CustomNumInput', label: '打样费', value: 'proofingFee' },
    { tag: 'CustomNumInput', label: '大货工期', value: 'deliveryTime' },
    { tag: 'CustomNumInput', label: '起订量', value: 'minNum' },
    { tag: 'CustomNumInput', label: '参考价（含税）', value: 'price' },
    { tag: 'el-input', label: '间采对接人', value: 'purchaseContactPerson' },
    {
      tag: 'el-radio',
      label: '是否为我司生产过此样品的大货',
      value: 'haveMassProduction',
      propData: [
        { code: 'YES', label: '是' },
        { code: 'NO', label: '否' }
      ]
    },
  ]
}
const FORM_MATCHUP = {
  EXP_INSTRUMENT: 'template_1',
  ELEC_CONTROL: 'template_2',
  POWER_SUPPLY: 'template_2',
  ELECTRON_COMPONENT: 'template_2',
  PROTECTIVE_EQUIPMENT: 'template_2',
  ELEC_TOOL: 'template_2',
  INSTRUMENT: 'template_2',
  PNEUMATIC_PART: 'template_2',
  OFFICE_SUPPLIES: 'template_2',
  STORAGE_TOOL: 'template_2',
  IT_PART: 'template_3',
  IT_SERVICE: 'template_4',
  AFTERNOON_TEA: 'template_5',
  SHUTTLE_RENTAL: 'template_5',
  DECORATION_AND_MAINTAIN: 'template_5',
  BUYING_AGENT: 'template_5',
  AROMATHERAPY_SERVICE: 'template_5',
  ADVERTISING_MATERIAL: 'template_5',
  ADMINISTRATION_MATERIAL: 'template_5',
  LABORATORY_CONSUMABLES: 'template_5',
  EVENT_PLAN: 'template_5',
  BOOK_FLIGHT: 'template_5',
  CAR_SERVICE: 'template_5',
  HOTEL_SERVICE: 'template_5',
  LIVE_ROOM_EQUIPMENT: 'template_5',
  THIRD_PARTY_SERVICE: 'template_6',
  TOURISM_SERVICE: 'template_7',
  OTHER_SERVICE: 'template_8',
  RESEARCH_SERVICE: 'template_9',
  OFFLINE: 'template_10',
  PRINTING: 'template_11',
  COSMETOLOGY: 'template_11',
  COSMETICS: 'template_11',
  TOYS: 'template_11',
  LUGGAGE: 'template_11',
  HOUSEHOLD: 'template_11',
  OTHER: 'template_11'
}
const FILE_List = {
  template_1: [
    { name: '设备技术介绍（配置清单）', multiple: true, field: 'techIntroFiles' },
    { name: '其它资料', multiple: true, field: 'otherFiles' },
  ],
  template_2: [
    { name: '附件', multiple: true, field: 'defaultFiles' },
  ],
  template_3: [
    { name: '附件', multiple: true, field: 'defaultFiles' },
  ],
  template_4: [
    { name: '费用标准', multiple: true, field: 'costStandardFiles' },
    { name: '其它资料', multiple: true, field: 'otherFiles' }
  ],
  template_5: [
    { name: '费用标准', multiple: true, field: 'costStandardFiles' },
    { name: '优势介绍', multiple: true, field: 'advantageIntroFiles' },
    { name: '其它资料', multiple: true, field: 'otherFiles' }
  ],
  template_6: [
    { name: '费用标准', multiple: true, field: 'costStandardFiles' },
    { name: '通用案例展示', multiple: true, field: 'generalCaseDemoFiles' },
    { name: '公司基本介绍', multiple: true, field: 'companyProfileFiles' },
    { name: '优势介绍', multiple: true, field: 'advantageIntroFiles' },
    { name: '检测服务类别', multiple: true, field: 'detectionServiceTypeFiles' },
    { name: '其它资料', multiple: true, field: 'otherFiles' }
  ],
  template_7: [
    { name: '费用标准', multiple: true, field: 'costStandardFiles' },
    { name: '通用案例展示', multiple: true, field: 'generalCaseDemoFiles' },
    { name: '公司基本介绍', multiple: true, field: 'companyProfileFiles' },
    { name: '优势介绍', multiple: true, field: 'advantageIntroFiles' },
    { name: '其它资料', multiple: true, field: 'otherFiles' }
  ],
  template_8: [
    { name: '费用标准', multiple: true, field: 'costStandardFiles' },
    { name: '通用案例展示', multiple: true, field: 'generalCaseDemoFiles' },
    { name: '公司基本介绍', multiple: true, field: 'companyProfileFiles' },
    { name: '优势介绍', multiple: true, field: 'advantageIntroFiles' },
    { name: '其它资料', multiple: true, field: 'otherFiles' }
  ],
  template_10: [
    { name: '其他现场照片', multiple: true, field: 'otherSiteImages' }
  ],
  template_11: [
    { name: '包装刀版文件', multiple: true, field: 'packagingDocumentFiles' },
    { name: '专利证书（若有，则提供）', multiple: true, field: 'patentsCredentialFiles' },
    { name: '相关质量体系证书', multiple: true, field: 'qualityCredentialFiles' },
    { name: '所用主要材质的安全证明（外检报告，MSDS）', multiple: true, field: 'msdsFiles' },
    { name: '产品适用的国家标准、行业标准或者企业标准', multiple: true, field: 'productStandardFiles' }
  ]
}
const FIRST_TYPE_URL = {
  'FACTORY_MRO_AND_FACILITY': 'pdMroFacility',
  'IT': 'pdIt',
  'EP_AND_ADMINISTRATION': 'pdEpAndAdministration',
  'PROFESSIONAL_SERVICE': 'pdProfessionalService',
  'OFFLINE': 'pdOffline',
  'MATERIAL': 'pdMaterial'
}
export {
  FORM_LIST,
  FORM_MATCHUP,
  FILE_List,
  FIRST_TYPE_URL
}